module.exports = {
  "acq-0164": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "acq-0177": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "su-0002": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  }
};